export const INLINE_STYLES = {
    display: "inline-block",
    width: "1em",
    height: "1em",
    strokeWidth: 0,
    position: "relative",
    top: "0.125em"
};
//# sourceMappingURL=helper.js.map